import { createApp } from 'vue'
import Vuex from 'vuex'
import App from './App.vue'
import router from './router'
import axios from 'axios'
import VueAxios from 'vue-axios'
//import 'semantic-ui-css/semantic.min.css'
import jquery from 'jquery'
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

const app = createApp(App)

app.use(Vuex)
app.use(router)
app.use(VueAxios, axios)
app.use(VueSweetalert2)
app.use(jquery)

var url = require('../static/config.json');

app.config.globalProperties.$url_hapiick = url.URL;
app.config.globalProperties.$subscription = url.SUBSCRIPTION;

app.mount('#app')

//createApp(App).mount('#app')
